'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _dates = require('MeetingsBase/constants/dates');

exports.default = (0, _immutable.Record)({
  duration: _dates.FIFTEEN_MINUTE_DURATION,
  formFields: null,
  dateString: null,
  dateTime: null
}, 'Event');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/models/Event.js
// module id = 236
// module chunks = 0